export const formMaskOptions: Record<string, string[]> = {
  countries: [
    'Türkiye',
    'Afganistan',
    'Alan Adaları',
    'Almanya',
    'Amerika Birleşik Devletleri',
    'Amerikan Samoası',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antartika',
    'Antigua ve Barbuda',
    'Arjantin',
    'Arnavutluk',
    'Aruba',
    'Avustralya',
    'Avusturya',
    'Azerbaycan',
    'Bahamalar',
    'Bahreyn',
    'Bangladeş',
    'Barbados',
    'Belarus',
    'Belçika',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Birleşik Arap Emirlikleri',
    'Birleşik Krallık',
    'Bolivya',
    'Bosna Hersek',
    'Botsvana',
    'Bouvet Adası',
    'Brezilya',
    'Britanya Hint Okyanusu Toprakları',
    'Brunei',
    'Bulgaristan',
    'Burkina Faso',
    'Burundi',
    'Cape Verde',
    'Cayman Adaları',
    'Cebelitarık',
    'Cezayir',
    'Cibuti',
    'Cook Adaları',
    'Çad',
    'Çekya',
    'Çin',
    'Danimarka',
    'Doğu Timor',
    'Dominik Cumhuriyeti',
    'Dominika',
    'Ekvador',
    'Ekvator Ginesi',
    'El Salvador',
    'Endonezya',
    'Eritre',
    'Ermenistan',
    'Estonya',
    'Esvatini',
    'Etiyopya',
    'Falkland Adaları',
    'Faroe Adaları',
    'Fas',
    'Fiji',
    'Fildişi Sahili',
    'Filipinler',
    'Filistin',
    'Finlandiya',
    'Fransa',
    'Fransız Güney Toprakları',
    'Gabon',
    'Gambiya',
    'Gana',
    'Gine',
    'Gine-Bissau',
    'Grenada',
    'Grönland',
    'Guam',
    'Guatemala',
    'Guyana',
    'Güney Afrika',
    'Güney Georgia ve Güney Sandwich Adaları',
    'Güney Kıbrıs Rum Kesimi',
    'Güney Kore',
    'Gürcistan',
    'Haiti',
    'Heard Adası ve Mcdonald Adaları',
    'Hırvatistan',
    'Hindistan',
    'Hollanda',
    'Hollanda Antilleri',
    'Honduras',
    'Hong Kong',
    'Irak',
    'İran',
    'İrlanda',
    'İspanya',
    'İsrail',
    'İsveç',
    'İsviçre',
    'İtalya',
    'İzlanda',
    'Jamaika',
    'Japonya',
    'Kamboçya',
    'Kamerun',
    'Kanada',
    'Karadağ',
    'Katar',
    'Kazakistan',
    'Kenya',
    'Kırgızistan',
    'Kiribati',
    'Kokos Adaları',
    'Kolombiya',
    'Komor',
    'Kongo Cumhuriyeti',
    'Kongo Demokratik Cumhuriyeti',
    'Kosova',
    'Kosta Rika',
    'Kuveyt',
    'Kuzey Kıbrıs Türk Cumhuriyeti',
    'Kuzey Kore',
    'Küba',
    'Laos',
    'Lesotho',
    'Letonya',
    'Liberya',
    'Libya',
    'Lihtenştayn',
    'Litvanya',
    'Lübnan',
    'Lüksemburg',
    'Macaristan',
    'Madagaskar',
    'Makao',
    'Makedonya',
    'Malavi',
    'Maldivler',
    'Malezya',
    'Mali',
    'Malta',
    'Marshall Adaları',
    'Mauritius',
    'Mayotte',
    'Meksika',
    'Mısır',
    'Mikronezya',
    'Moğolistan',
    'Moldova',
    'Montserrat',
    'Moritanya',
    'Mozambik',
    'Myanmar',
    'Namibya',
    'Nauru',
    'Nepal',
    'Nijer',
    'Nijerya',
    'Nikaragua',
    'Noel Adası',
    'Norfolk Adası',
    'Norveç',
    'Orta Afrika Cumhuriyeti',
    'Özbekistan',
    'Pakistan',
    'Palau',
    'Panama',
    'Papua Yeni Gine',
    'Paraguay',
    'Peru',
    'Pitcairn',
    'Polonya',
    'Portekiz',
    'Romanya',
    'Ruanda',
    'Rusya',
    'Saint Helena',
    'San Marino',
    'Senegal',
    'Seyşeller',
    'Sırbistan',
    'Sierra Leone',
    'Singapur',
    'Slovakya',
    'Slovenya',
    'Solomon Adaları',
    'Somali',
    'Sri Lanka',
    'St Kitts ve Nevis',
    'St Lucia',
    'St Vincent ve Grenadinler',
    'Sudan',
    'Surinam',
    'Suriye',
    'Suudi Arabistan',
    'São Tomé ve Príncipe',
    'Şili',
    'Tacikistan',
    'Tanzanya',
    'Tayland',
    'Tayvan',
    'Togo',
    'Tokelau',
    'Tonga',
    'Tunus',
    'Turks ve Caicos Adaları',
    'Tuvalu',
    'Türkmenistan',
    'Uganda',
    'Ukrayna',
    'Umman',
    'Uruguay',
    'Ürdün',
    'Wallis ve Futuna Adaları',
    'Vanuatu',
    'Vatikan',
    'Venezuela',
    'Vietnam',
    'Virgin Adaları',
    'Yemen',
    'Yeni Kaledonya',
    'Yeni Zelanda',
    'Yunanistan',
    'Zambiya',
    'Zimbabve',
  ],
  income_ranges: [
    '0 TL - 25.000 TL',
    '25.000 TL - 100.000 TL',
    '100.000 TL - 500.000 TL',
    '500.000 TL - 1.000.000 TL',
    '1.000.000 TL - 2.500.000 TL',
    '2.500.000 TL - 5.000.000 TL',
    '5.000.000 TL +',
  ],
  income_sources: ['Maaş ve serbest meslek geliri', 'Ticari gelir', 'Yatırım'],
  months: [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık',
  ],
  networks: [
    'ERC 20',
    'TRC',
    'SOL',
    'ADA',
    'ALGO',
    'APT',
    'ARB',
    'ATOM',
    'AVAX C',
    'AVAX  X',
    'BCH',
    'BSC',
    'BTC',
    'CHZ 1',
    'CHZ 2',
    'DOGE',
    'DOT',
    'DYM',
    'EOS',
    'FLR',
    'ICP',
    'LTC',
    'MANTA',
    'MINA',
    'MIOTA',
    'NEO',
    'OMNI',
    'ONT',
    'OP',
    'MATIC',
    'RVN',
    'SEI',
    'SUI',
    'THETA',
    'TIA',
    'TON',
    'VET',
    'WAVES',
    'XLM',
    'XRP',
    'XTZ',
    'ZIL',
    'DİĞER',
  ],
  professions: [
    'Aşçı/Garson/Barmen/ Mutfak Personeli',
    'Polis/Asker',
    'Avukat',
    'Bakkal/Market/Kasap/Manav',
    'Berber/Kuaför/Güzellik Uzmanı',
    'Borsacı/Finansçı/Ekonomist/Bankacı/ Sigortacı',
    'Boyacı/Elektrikçi/Tesisatçı/Teknisyen/Tamirci/Marangoz/Mobilyacı',
    'Çalışmıyor/ Öğrenci/ Ev Hanımı/ İşsiz',
    'Çiftçi/Besici/Balıkçı/Ormancı',
    'Doktor/Diş Hekimi/Eczacı/Diyetisyen/Psikolog/Veteriner/Fizyoterapist/Hemşire',
    'Emekli',
    'Gazeteci/ Yazar/ Editör',
    'Emlak/Gümrük Komisyoncusu',
    'Hakim/Savcı',
    'İşletmeci (Kafe/Otel/Restoran/Eğlence)',
    'Memur',
    'Menejer/Yapımcı/Yönetmen/Organizatör/ Reklamcı',
    'Mimar/İç Mimar/Mühendis',
    'Muhasebeci/Mali Müşavir/Danışman',
    'Müteahhit',
    'Noter',
    'Öğretim Görevlisi/Akademisyen/Öğretmen/Eğitmen',
    'Hostes/Şoför/Güvenlik Görevlisi',
    'Programcı/Yazılımcı/Analist',
    'Rehber/Tur Operatörü',
    'Serbest Meslek',
    'Oyuncu /Sanatçı (Yazar/Ressam/Ses/Film/Tiyatro)',
    'Sivil Pilot/Kaptan',
    'Sporcu/Antrenör/Hakem',
    'Tasarımcı (Grafik/Moda/Sanat/Reklam Vs)',
    'Esnaf/Zanaatkar',
    'Kaymakam/ Vali/ Belediye Başkanı',
    'Milletvekili, Bakan, Müsteşar, Bürokrat',
    'Özel Sektör Üst Düzey Yönetici/ Genel Müdür',
    'Kuyumcu/Sarraf Sahibi/Ortağı/ Yöneticisi',
    'Büro/ Ofis Çalışanı/ Sekreter/ Tezgahtar',
    'Döviz Bürosu Sahibi/Ortağı/ Yöneticisi',
    'Oto Galeri Sahibi/Ortağı/ Yöneticisi',
    'General/ Amiral (Üst Düzey Askeri Görevli)',
  ],
  transaction_frequencies: ['0-100 işlem', '100 işlem ve üzeri'],
  transaction_purposes: ['Alım-satım', 'Yatırım'],
  transaction_volumes: ['0 TL - 500 bin TL', '500 bin TL üzeri'],
  currency_list: [
    'Bitcoin (BTC)',
    'Litecoin (LTC)',
    'Ethereum (ETH)',
    'Ripple (XRP)',
    'Stellar (XLM)',
    'Chainlink (LINK)',
    'Holo (HOT)',
    'Bat (BAT)',
    'Ravencoin (RVN)',
    'Eos (EOS)',
    'Neo (NEO)',
    'Tron (TRX)',
    'Bitcoin Cash (BCH)',
    'Tether (USDT)',
    'Cardano (ADA)',
    'Doge (DOGE)',
    'Waves (WAVES)',
    'Chiliz (CHZ)',
    'Tezos (XTZ)',
    'Ontology (ONT)',
    'Cosmos (ATOM)',
    'Galatasaray (GAL)',
    'Trabzonspor (TRA)',
    'Polkadot (DOT)',
    'Juventus (JUV)',
    'Psg (PSG)',
    'Avalanche (AVAX)',
    'Maker (MKR)',
    'OMG Network (OMG)',
    'Uniswap (UNI)',
    'Aave (AAVE)',
    'Balancer (BAL)',
    'AS Roma (ASR)',
    'Atletico De Madrid (ATM)',
    'AC Milan (ACM)',
    'FC Barcelona (BAR)',
    'Reef (REEF)',
    'Loopring (LRC)',
    'Manchester City FC (CITY)',
    'Band Protocol (BAND)',
    'Zilliqa (ZIL)',
    'Algorand (ALGO)',
    'Enjin Coin (ENJ)',
    'The Graph (GRT)',
    'Theta (THETA)',
    'Origin Protocol (OGN)',
    'Polygon (POL)',
    'Orchid (OXT)',
    'Curve DAO Token (CRV)',
    'Decentraland (MANA)',
    'Miota (IOTA)',
    'Mina (MINA)',
    'Solana (SOL)',
    'VeChain (VET)',
    'Fenerbahçe (FB)',
    'Ankr (ANKR)',
    'Inter Milan (INTER)',
    'Shiba (SHIB)',
    'Arsenal FC (AFC)',
    'Internet Computer (ICP)',
    'Fantom (FTM)',
    'Injective Protocol (INJ)',
    'Livepeer (LPT)',
    'Axie Infinity (AXS)',
    'Ethereum Name Service (ENS)',
    'Audius (AUIDO)',
    'The Sandbox (SAND)',
    'Tryc (TRYC)',
    'Clover Finance (CLV)',
    'Alien Worlds (TLM)',
    'MyNeighborAlice (ALICE)',
    'Gala (GALA)',
    'Ceek VR (CEEK)',
    'Radio Caca (RACA)',
    'Göztepe SK (GOZ)',
    'Valencia CF (VCF)',
    'Star Atlas (ATLAS)',
    'Bittorrent (BTTC)',
    'Napoli (NAP)',
    'Prb (PRB)',
    'ApeCoin (APE)',
    'Uma (UMA)',
    'USD Coin (USDC)',
    'AS Monaco (ASM)',
    'Storj (STORJ)',
    '1inch Network (1INCH)',
    'Synthetix (SNX)',
    'Compound (COMP)',
    'Artificial Superintelligence (FET)',
    'Radicle (RAD)',
    'Spell Token (SPELL)',
    'Portugal NT (POR)',
    'Argentine FA (ARG)',
    'Quant (QNT)',
    'Stargate Finance (STG)',
    'Aptos (APT)',
    'Flare (FLR)',
    'Render Token (RENDER)',
    'Arbitrum (ARB)',
    'Immutable X (IMX)',
    'Aston Villa (AVL)',
    'Sui (SUI)',
    'Sevilla FC (SEVILLA)',
    'Aston Martin (ASTON)',
    'Alfa Romeo (SAUBER)',
    'Cartesi (CTSI)',
    'Optimism (OP)',
    'Pepe (PEPE)',
    'Ocean Protocol (OCEAN)',
    'iExec RLC (RLC)',
    'Skale (SKL)',
    'Blur (BLUR)',
    'SingularityNET (AGIX)',
    'Mask Network (MASK)',
    'Italy (ITA)',
    'Golem (GLM)',
    'dYdX (DYDX)',
    'PDA\tPlayDapp',
    'Floki (FLOKI)',
    'Radiant Capital (RDNT)',
    'Everton (EFC)',
    'Sei (SEI)',
    'Beşiktaş (BJK)',
    'Tottenham Hotspur (SPURS)',
    'Celestia (TIA)',
    'Toncoin (TON)',
    'Vanar (VANRY)',
    'Threshold (T)',
    'API3 (API3)',
    'Bonk (BONK)',
    'Memecoin (MEME)',
    'Jito (JTO)',
    'Trader Joe (JOE)',
    'Pyth Network (PYTH)',
    'Beam (BEAM)',
    '0x Protocol (ZRX)',
    'Helium (HNT)',
    'SL Benfica (BENFICA)',
    'Manta Network (MANTA)',
    'Pendle (PENDLE)',
    'Numeraire (NMR)',
    'Treasure (MAGIC)',
    'Jupiter (JUP)',
    'Dymension (DYM)',
    'Starknet (STRK)',
    'Xai (XAI)',
    'Worldcoin (WLD)',
    'Illuvium (ILV)',
    'JasmyCoin (JASMY)',
    'Wormhole (W)',
    'Ether.fi (ETHFI)',
    'Tensor (TNSR)',
    'ZETA (ZetaChain)',
    'Arkham (ARKM)',
    'Axelar (AXL)',
    'LayerZero (ZRO)',
    'Raydium (RAY)',
    'Ondo (ONDO)',
    'Filecoin (FILE)',
    'Mantle (MNT)',
    'Synapse (SYN)',
    'Altlayer (ALT)',
    'zkSync (ZK)',
    'Ethena (ENA)',
    'Aevo (AEVO)',
    'Samsunspor Fan Token (SAM)',
    'Lido DAO (LDO)',
    'Io.net (IO)',
    'Dogwifhat (WIF)',
    'EigenLayer (EIGEN)',
    'Goatseus Maximus (GOAT)',
    'Magic Eden (ME)',
    'Peanut the Squirrel (PNUT)',
    'Odos Protocol (ODOS)',
    'Movement (MOVE)',
  ],
}
